/**
 * LoginModal - Redirects to centralized auth or allows guest mode
 */
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const LoginModal = ({ isOpen, onClose }) => {
  const { continueAsGuest, redirectToAuth } = useAuth();

  if (!isOpen) return null;

  const handleLogin = () => {
    redirectToAuth('login');
  };

  const handleSignup = () => {
    redirectToAuth('signup');
  };

  const handleContinueAsGuest = () => {
    continueAsGuest();
    onClose();
  };

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} onClick={onClose}></div>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-box-arrow-in-right me-2"></i>
                Connexion requise
              </h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <p className="text-muted mb-4">
                Connectez-vous pour sauvegarder vos tournois et y accéder depuis n'importe quel appareil.
              </p>

              <button type="button" className="btn btn-primary w-100 mb-3" onClick={handleLogin}>
                <i className="bi bi-box-arrow-in-right me-2"></i>
                Se connecter
              </button>

              <button type="button" className="btn btn-outline-primary w-100 mb-3" onClick={handleSignup}>
                <i className="bi bi-person-plus me-2"></i>
                Créer un compte
              </button>

              <div className="d-flex align-items-center mb-3">
                <hr className="flex-grow-1" />
                <span className="px-3 text-muted small">ou</span>
                <hr className="flex-grow-1" />
              </div>

              <button type="button" className="btn btn-outline-secondary w-100" onClick={handleContinueAsGuest}>
                <i className="bi bi-person me-2"></i>
                Continuer en mode invité
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginModal;
